<template>
  <div
    v-if="props.clickable"
    class="description-field description-field--clickable scrollbar"
    :style="{ height }"
    @click.stop="openEditDialog"
    v-tooltip:top="'Click to edit description'"
  >
    <div class="description-field__content">
      {{ displayText || '(no description)' }}
    </div>
  </div>
  <div
    v-else
    class="description-field scrollbar"
    :style="{ height }"
  >
    <div class="description-field__content">
      {{ displayText || '(no description)' }}
    </div>
  </div>

  <div v-if="showDialog" class="modal-overlay" @click="closeEditDialog">
    <div class="modal-dialog" @click.stop>
      <BaseDialog
        :title="'Edit Description'"
        :footerButtons="['Cancel', 'Save']"
        @cancel="closeEditDialog"
        @footer-click="handleFooterClick"
      >
        <div class="form-grid">
          <div class="form-group">
            <label for="description-field-edit">Description</label>
            <textarea
              id="description-field-edit"
              v-model="draftDescription"
              class="select"
              rows="5"
              placeholder="Enter description"
            ></textarea>
          </div>
        </div>
      </BaseDialog>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, watch } from 'vue';
import BaseDialog from '@/components/DilaogTemplate/BaseDialog.vue';

const props = defineProps({
  text: {
    type: String,
    default: '',
  },
  height: {
    type: String,
    default: '80px',
  },
  clickable: {
    type: Boolean,
    default: true,
  },
  data: {
    type: [Object, String, Number],
    default: null,
  },
});

const emit = defineEmits(['click', 'description-changed']);

const showDialog = ref(false);
const draftDescription = ref(props.text || '');
const displayText = ref(props.text || '');

watch(
  () => props.text,
  (value) => {
    displayText.value = value || '';
    if (!showDialog.value) {
      draftDescription.value = value || '';
    }
  },
);

function openEditDialog() {
  emit('click');
  draftDescription.value = displayText.value || '';
  showDialog.value = true;
}

function closeEditDialog() {
  showDialog.value = false;
}

function handleFooterClick(buttonLabel) {
  const normalized = String(buttonLabel || '').toLowerCase();
  if (normalized === 'save') {
    displayText.value = draftDescription.value || '';
    emit('description-changed', draftDescription.value || '');
    closeEditDialog();
  }
}

defineExpose({
  openEditDialog,
});
</script>

<style lang="scss" scoped>
.description-field {
  overflow-y: auto;
  overflow-x: hidden;
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.4;
  font-style: italic;
  padding-top: 4px;
  color:rgb(4, 52, 124);
  cursor: default;
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;

  .description-field__content {
    word-break: break-word;
    overflow-wrap: break-word;
  }
}

.description-field--clickable {
  cursor: pointer;
}

.modal-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(0, 0, 0, 0.45);
  z-index: 2000;
}

.modal-dialog {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

